import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'
import { IoIosSearch } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaRegFileExcel } from 'react-icons/fa6';
import Swal from 'sweetalert2';
import TabHead from '../../components/TabHead';
import HourLoading from '../../components/HourLoading';
import { MdAdsClick } from 'react-icons/md';



const MesPointages = () => {
    const [errors, setErrors] = useState(null);

    const [loading, setLoading] = useState(false);
    const [mesPointages, setMesPointages] = useState([]);
    const { token, setToken, user } = useStateContext();
    const tableRef = useRef();
    const [req, setReq] = useState({
        DateDebut: '',
        DateFin: '',
        exp: '',
    });
    const navigate = useNavigate();

    const supprimer = (mesPointage) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/mesPointage/' + mesPointage.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getMesPointages();
                    }).catch(err => {
                        const response = err.response;
                        if (err.response.status === 401) {
                            setToken(null);
                        } else {
                            if (response.status === 401) {
                                setToken(null);
                            }
                            else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
                        }

                    })
            }
        });
    }

    useEffect(() => {

    }, [])

    const getMesPointages = () => {
        setLoading(true);
        axiosClient.get('/mesPointages?DateDebut=' + req.DateDebut + '&DateFin=' + req.DateFin)
            .then(response => {
                setMesPointages(response.data.pointages);
                setLoading(false);
                setErrors(null);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }


    return (
        <>
            <Header icon={<MdAdsClick />} title="MesPointages" titleAr="الحضور" />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between items-center'>
                <Input label="Date debut" labelAr="من" type="date" value={req.DateDebut} onChange={ev => setReq({ ...req, DateDebut: ev.target.value })} required="required" />
                <Input label="Date fin" labelAr="الى" type="date" value={req.DateFin} onChange={ev => setReq({ ...req, DateFin: ev.target.value })} required="required" />
                <div className=' flex gap-2 mt-8'>
                    <Button onClick={() => getMesPointages()} color="bg-yellow-500" icon={<IoIosSearch />} size="20" text="Chercher" textColor="text-white" />
                    <DownloadTableExcel
                        filename="MesPointages"
                        sheet="mesPointages"
                        currentTableRef={tableRef.current}
                    >
                        <Button color="bg-green-500" icon={<FaRegFileExcel />} size="20" text="Exporter" textColor="text-white" />

                    </DownloadTableExcel>
                </div>
            </div>
            
            <div className="flex my-2">
                <h1 className='text-red-500 font-bold'>Total: {mesPointages.reduce((n, {montant}) => n + parseFloat(montant), 0)} MRU</h1>
            </div>
            <div className='flex mt-3 overflow-auto'>
                <table ref={tableRef} className='table-auto' >
                    <thead>
                        <tr>
                            <th><TabHead left="Date" right="التاريخ"/> </th>
                            <th><TabHead left="Jour" right="يوم"/></th>
                            <th><TabHead left="Matière" right="المادّة"/></th>
                            <th><TabHead left="Classe" right="المستفيد"/></th>
                            <th><TabHead left="Montant" right="القيمة"/></th>
                            
                        </tr>
                    </thead>
                    {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="6"><HourLoading /></td></tr></tbody> :
                        <tbody>
                            {mesPointages.map(o => (
                                <tr>
                                    <td>{o.dateCours}</td>
                                    <td>{o.jourLibelle}</td>
                                    <td>{o.matiereLibelle}</td>
                                    <td>{o.classe}</td>
                                    <td>{o.montant}</td>
                                </tr>
                            ))

                            }
                        </tbody>
                    }

                </table>
                
            </div>
            

        </>
    )
}

export default MesPointages